import React, { Fragment, useState, useEffect, useCallback } from "react";
import {
  Nav,
  Navbar,
  Container,
  ListGroup,
  Button,
  Image,
  Dropdown,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { Link, Redirect } from "react-router-dom";
import GetActiveLcdData from "../../common/getActiveLcdData";
import {
  getHeaderForAxios,
  getSelectedLanguageOptions,
  getToken,
  getUserData,
} from "../../common/getLocalStorageData";
import { ILcdData, IReduxStateData } from "../../interfaces/redux";
import {
  activeDealAdvertisement,
  loginLogoutUserAction,
  setLanguageAction,
} from "../../actions";
import { isMobile } from "react-device-detect";
import "../../assets/css/scss/component/_header.scss";
import { HEADER_MENU } from "../../constant/menuAndProfile";
import { deal_type } from "../../constant/deal";
import axios from "axios";

export default function Header(props: any) {
  // var isLogin = getToken();
  const [isLogin, setIsLogin] = useState(getToken() ? true : false);
  const dispatch = useDispatch();
  const [toggle, setToggle] = useState(false);
  const [activeLcdData, setActiveLcdData] = useState<ILcdData | undefined>();

  const alreadySelectedLang = getSelectedLanguageOptions();
  const [isHovered, setIsHovered] = useState(false);
  const [isClicked, setIsClicked] = useState(false);
  const [isExpanded, setIsExpanded] = useState(false);
  const [selectedLang, changeSelectedLang] = useState(
    alreadySelectedLang || "en"
  );

  const [isPlayersHovered, setIsPlayersHovered] = useState(false);
  const [isPlayersClicked, setIsPlayersClicked] = useState(false);
  const [selectedPlayers, changeSelectedPlayers] = useState(0);
  const [teamsDetail, setTeamsDetails] = useState([]);

  const [allowedCamera, setAllowedCamera] = useState<boolean>(true);
  const [redirecToScan, setRedirectToScan] = useState<boolean>(false);

  const globalState = useSelector((state: IReduxStateData) => state);
  const globalActiveLcdIdentifierState = useSelector(
    (state: IReduxStateData) => state.activeLcdAlphaIdentifier
  );
  const isUserLogin = useSelector(
    (state: IReduxStateData) => state.isUserLogin
  );
  const onLogout = () => {
    localStorage.clear();
    loginLogoutUserInRedux({ isUserLogin: false });
    setToggle(!toggle);
  };
  const activeDealAdvertisementData = useCallback(
    (advertisementData) => {
      dispatch(activeDealAdvertisement(advertisementData));
    },
    // eslint-disable-next-line
    [dispatch]
  );

  useEffect(() => {
    if (globalActiveLcdIdentifierState) {
      const activeLcdDetail = GetActiveLcdData(globalState);
      if (activeLcdDetail?.deal_uuid) {
        getActiveDealAdvertisement(activeLcdDetail?.deal_uuid);
      }
    }
  }, [globalActiveLcdIdentifierState, isLogin]);

  const getActiveDealAdvertisement = async (dealUuid: string) => {
    if (isLogin) {
      const userId = getUserData();
      if (
        userId &&
        dealUuid &&
        dealUuid !== globalState.previousFetchAdvertisementDeal
      ) {
        await axios
          .post(
            process.env.REACT_APP_API_URL + "/deal/get-advertisement",
            {
              user_uuid: userId,
              deal_uuid: dealUuid,
            },
            { headers: getHeaderForAxios() }
          )
          .then(function (response) {
            if (response.data && response.data.success) {
              activeDealAdvertisementData(
                response.data.success?.advertisement || []
              );
            }
          })
          .catch(function (error) {
            // handle error
            console.log(error);
          });
      }
    }
  };
  const fetchTeamsNames = (identifiers: any) => {
    if (Array.isArray(identifiers) && identifiers.length) {
      let postData = {
        teams_identifier: identifiers,
        limit: 50,
      };
      axios
        .post(
          process.env.REACT_APP_API_URL + "/match/getTeamsPartialDetail",
          postData,
          { headers: getHeaderForAxios() }
        )
        .then(function (response) {
          if (response.data.success?.teams_data) {
            setTeamsDetails(response.data.success?.teams_data);
          } else {
            setTeamsDetails([]);
          }
        })
        .catch(function (error) {
          // handle error
          setTeamsDetails([]);
          console.log(error);
        });
    }
  };
  useEffect(() => {
    const activeLcdDetail = GetActiveLcdData(globalState);
    setActiveLcdData(activeLcdDetail);
    if (
      activeLcdDetail?.is_player === deal_type["teams_deal"] &&
      activeLcdDetail?.tp_identifier &&
      activeLcdDetail?.tp_identifier?.split(",").length
    ) {
      fetchTeamsNames(activeLcdDetail?.tp_identifier?.split(","));
    }
    if (globalActiveLcdIdentifierState) {
      const activeLcdDetail = GetActiveLcdData(globalState);
      if (activeLcdDetail?.deal_uuid) {
        getActiveDealAdvertisement(activeLcdDetail?.deal_uuid);
      }
    }
    setToggle(!toggle);
  }, [globalActiveLcdIdentifierState, globalState]);

  useEffect(() => {
    setIsLogin(getToken() ? true : false);
  }, [isUserLogin]);

  const loginLogoutUserInRedux = useCallback(
    (data) => {
      dispatch(loginLogoutUserAction(data));
    },
    // eslint-disable-next-line
    [dispatch]
  );

  const enumeratorPromise = () => {
    navigator.mediaDevices.enumerateDevices().then(function (devices) {
      const mediaConstraints = {
        video: true,
      };
      const cam = devices.find(function (device) {
        return device.kind === "videoinput";
      });
      var constraints = { video: cam && mediaConstraints.video };
      return navigator.mediaDevices
        .getUserMedia(constraints)
        .then(function (stream) {
          stream.getTracks().forEach(function (track) {
            track.stop();
          });
          setRedirectToScan(true);
        })
        .catch(function (err) {
          setAllowedCamera(false);
        });
    });
  };
  useEffect(() => {
    if (redirecToScan) {
      setTimeout(() => {
        setRedirectToScan(false);
      }, 200);
    }
  }, [redirecToScan]);

  const setLanguageRedux = useCallback(
    (data) => {
      dispatch(setLanguageAction(data));
    },
    // eslint-disable-next-line
    [dispatch]
  );

  const changeLaunguage = (e, selectedItem: string) => {
    setLanguageRedux({ selectedLang: selectedItem });
    changeSelectedLang(selectedItem);
    setIsHovered(false);
    setIsClicked(false);
    e.preventDefault();
  };

  const changePlayersItem = (e, selectedItem: number) => {
    changeSelectedPlayers(selectedItem);
    setIsPlayersHovered(false);
    setIsPlayersClicked(false);
    // e.preventDefault();
  };

  const onClickNavItem = () => {
    if (isExpanded) {
      setIsExpanded(false);
    }
  };
  const displayTPTabs =
    isLogin && activeLcdData !== undefined && activeLcdData.tp_identifier;
  return (
    <Fragment key={toggle && displayTPTabs ? "1" : "0"}>
      {redirecToScan && allowedCamera ? (
        <Redirect
          to={{
            pathname: "/scan",
            state: { allowedCamera: true },
          }}
        />
      ) : null}
      {/* <!-- header section -->   */}
      {props?.isComingSoon ? (
        <header
          className="sticky-top position-absolute w-100 header-transparent"
          id="header-container"
        >
          <Container className="p-md-0">
            <Navbar collapseOnSelect expand="lg" className="p-0">
              <Navbar.Brand as={Link} to="/">
                {/* <Link className="navbar-brand" to="/"> */}
                <Image
                  src="/assets/images/header-logo-white.svg"
                  alt="site logo"
                  fluid
                  width={60}
                  height={30}
                />
                {/* </Link> */}
              </Navbar.Brand>
            </Navbar>
          </Container>
        </header>
      ) : (
        <header
          className="sticky-top theme-bg-white"
          id="header-white-container"
        >
          <Container className="p-md-0">
            <Navbar collapseOnSelect expand="lg" className="p-0">
              <Navbar.Brand as={Link} to="/" onClick={() => onClickNavItem()}>
                {/* <Link className="navbar-brand" to="/"> */}
                <Image
                  src="/assets/images/header-logo.png"
                  alt="site logo"
                  fluid
                  width={isMobile ? 60 : 50}
                  height={30}
                />
                {/* </Link> */}
              </Navbar.Brand>
              <Navbar.Toggle
                aria-controls="responsive-navbar-nav"
                onClick={() => setIsExpanded(!isExpanded)}
              />
              <Navbar.Collapse id="responsive-navbar-nav" in={isExpanded}>
                <Nav
                  defaultActiveKey="/"
                  className="ml-auto align-items-center"
                  as="ul"
                >
                  {/* <Nav.Item as="li" onClick={() => onClickNavItem()}>
                    <Nav.Link
                      as={Link}
                      to="/"
                      className="nav-link bold position-relative"
                    >
                      {HEADER_MENU[selectedLang]['home']}
                    </Nav.Link>
                  </Nav.Item> */}
                  {displayTPTabs ? (
                    <Fragment>
                      {activeLcdData?.is_player === deal_type["teams_deal"] ? (
                        <Fragment>
                          <Nav.Item as="li" onClick={() => onClickNavItem()}>
                            <Nav.Link
                              as={Link}
                              to={"/teams"}
                              className="nav-link bold position-relative"
                            >
                              {HEADER_MENU[selectedLang]["teams"]}
                            </Nav.Link>
                          </Nav.Item>
                          {teamsDetail.length ? (
                            <Nav.Item as="li">
                              <Dropdown
                                className="nav-dropdown-wrapper nav-link position-relative bold"
                                onMouseEnter={() => setIsPlayersHovered(true)}
                                onMouseLeave={() => setIsPlayersHovered(false)}
                                show={isPlayersClicked || isPlayersHovered}
                              >
                                <Dropdown.Toggle
                                  variant="normal"
                                  className="bold"
                                  id="dropdown-basic"
                                >
                                  {HEADER_MENU[selectedLang]["players"]}
                                </Dropdown.Toggle>
                                <Dropdown.Menu className="nav-dropdown-menu-wrapper m-0">
                                  {teamsDetail.map((item: any, index) => (
                                    <Dropdown.Item
                                      className="text-capitalize"
                                      as={Link}
                                      to={`/players/${item.identifier}`}
                                      active={selectedPlayers === index + 1}
                                      onClick={(e) => {
                                        changePlayersItem(e, index + 1);
                                        onClickNavItem();
                                      }}
                                    >
                                      {item?.name}
                                    </Dropdown.Item>
                                  ))}
                                </Dropdown.Menu>
                              </Dropdown>
                            </Nav.Item>
                          ) : null}
                        </Fragment>
                      ) : null}
                      {activeLcdData?.is_player ===
                      deal_type["players_deal"] ? (
                        <Nav.Item as="li" onClick={() => onClickNavItem()}>
                          <Nav.Link
                            as={Link}
                            to={"/players"}
                            className="nav-link bold position-relative"
                          >
                            {HEADER_MENU[selectedLang]["players"]}
                          </Nav.Link>
                        </Nav.Item>
                      ) : null}
                      {activeLcdData?.is_player === deal_type["player_deal"] ? (
                        <Nav.Item as="li" onClick={() => onClickNavItem()}>
                          <Nav.Link
                            as={Link}
                            to={`/player/${activeLcdData.tp_identifier}`}
                            className="nav-link bold position-relative"
                          >
                            {HEADER_MENU[selectedLang]["player"]}
                          </Nav.Link>
                        </Nav.Item>
                      ) : null}
                      {activeLcdData?.is_player === deal_type["team_deal"] ? (
                        <Fragment>
                          <Nav.Item as="li" onClick={() => onClickNavItem()}>
                            <Nav.Link
                              as={Link}
                              to={`/team/${activeLcdData.tp_identifier}`}
                              className="nav-link bold position-relative"
                            >
                              {HEADER_MENU[selectedLang]["team"]}
                            </Nav.Link>
                          </Nav.Item>
                          <Nav.Item as="li" onClick={() => onClickNavItem()}>
                            <Nav.Link
                              as={Link}
                              to={`/players/${activeLcdData.tp_identifier}`}
                              className="nav-link bold position-relative"
                            >
                              {HEADER_MENU[selectedLang]["players"]}
                            </Nav.Link>
                          </Nav.Item>
                        </Fragment>
                      ) : null}
                    </Fragment>
                  ) : null}
                  {/* {isLogin &&
                    activeLcdData !== undefined &&
                    activeLcdData.tp_identifier ? (
                    <Nav.Item as="li" onClick={() => onClickNavItem()}>
                      <Nav.Link
                        as={Link}
                        to={
                          activeLcdData.is_player ===
                            1
                            ? "/player/" +
                            activeLcdData.tp_identifier
                            : "/team/" +
                            activeLcdData.tp_identifier
                        }
                        className="nav-link bold position-relative"
                      >
                        {activeLcdData.is_player === 1
                          ? HEADER_MENU[selectedLang]['player']
                          : HEADER_MENU[selectedLang]['team']}
                      </Nav.Link>
                    </Nav.Item>
                  ) : null}

                  {isLogin &&
                    activeLcdData !== undefined &&
                    activeLcdData.tp_identifier &&
                    activeLcdData.is_player === 2 ? (
                    <Nav.Item as="li" onClick={() => onClickNavItem()}>
                      <Nav.Link
                        as={Link}
                        to={
                          "/players/" +
                          activeLcdData.tp_identifier
                        }
                        className="nav-link bold position-relative"
                      >
                        {HEADER_MENU[selectedLang]['players']}
                      </Nav.Link>
                    </Nav.Item>
                  ) : null} */}
                  <Nav.Item as="li" onClick={() => onClickNavItem()}>
                    <Nav.Link
                      // as={Link}
                      // to={"/scan"}
                      className="nav-link bold position-relative"
                      onClick={() => enumeratorPromise()}
                    >
                      {HEADER_MENU[selectedLang]["qr_code"]}
                    </Nav.Link>
                  </Nav.Item>
                  {isLogin ? (
                    <Nav.Item as="li" onClick={() => onClickNavItem()}>
                      <Nav.Link
                        as={Link}
                        to={"/gallery"}
                        className="nav-link bold position-relative"
                      >
                        {HEADER_MENU[selectedLang]["gallery"]}
                      </Nav.Link>
                    </Nav.Item>
                  ) : null}
                  <Nav.Item as="li">
                    <Dropdown
                      className="nav-dropdown-wrapper nav-link position-relative bold"
                      onMouseEnter={() => setIsHovered(true)}
                      // onToggle={() => setIsClicked(!isClicked)}
                      onMouseLeave={() => setIsHovered(false)}
                      show={isClicked || isHovered}
                    >
                      <Dropdown.Toggle
                        variant="normal"
                        className="bold"
                        id="dropdown-basic"
                      >
                        <i className="fa fa-globe" aria-hidden="true" />{" "}
                        {selectedLang === "sp"
                          ? HEADER_MENU[selectedLang]["language_sp"]
                          : HEADER_MENU[selectedLang]["language_en"]}
                      </Dropdown.Toggle>
                      <Dropdown.Menu className="nav-dropdown-menu-wrapper m-0">
                        <Dropdown.Item
                          active={selectedLang === "en"}
                          onClick={(e) => {
                            changeLaunguage(e, "en");
                            onClickNavItem();
                          }}
                        >
                          {HEADER_MENU[selectedLang]["language_en"]}
                        </Dropdown.Item>
                        <Dropdown.Item
                          active={selectedLang === "sp"}
                          onClick={(e) => {
                            changeLaunguage(e, "sp");
                            onClickNavItem();
                          }}
                        >
                          {HEADER_MENU[selectedLang]["language_sp"]}
                        </Dropdown.Item>
                      </Dropdown.Menu>
                    </Dropdown>
                  </Nav.Item>
                  {isLogin ? (
                    <Nav.Item as="li" onClick={() => onClickNavItem()}>
                      <Nav.Link
                        as={Link}
                        to={"/user/profile"}
                        className="nav-link bold position-relative"
                      >
                        {HEADER_MENU[selectedLang]["profile"]}
                      </Nav.Link>
                    </Nav.Item>
                  ) : // <Nav.Item as="li" onClick={() => onClickNavItem()}>
                  //   <Nav.Link
                  //     href="#fan-corner"
                  //     className="nav-link bold position-relative"
                  //   >
                  //     {HEADER_MENU[selectedLang]['fan_corner']}
                  //   </Nav.Link>
                  // </Nav.Item>
                  null}
                  <ListGroup.Item
                    as="li"
                    className="p-0"
                    onClick={() => onClickNavItem()}
                  >
                    {!isLogin ? (
                      // <Button>Log In</Button>
                      <Link className="btn btn-primary" to={"/login"}>
                        {HEADER_MENU[selectedLang]["login"]}
                      </Link>
                    ) : (
                      <Link
                        className="btn btn-primary"
                        to={"/login"}
                        onClick={() => {
                          onLogout();
                          onClickNavItem();
                        }}
                      >
                        {HEADER_MENU[selectedLang]["logout"]}
                      </Link>
                    )}
                  </ListGroup.Item>
                </Nav>
              </Navbar.Collapse>
            </Navbar>
          </Container>
        </header>
      )}
      {/* <!-- header section --> */}
    </Fragment>
  );
}
